import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  UpdateBookingMutationMutation,
  UpdateBookingMutationMutationVariables,
} from '@gql/graphql';
import type { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import { BOOKING_LIST_GET_BOOKINGS } from './useGetBookings';

export const UPDATE_BOOKING = graphql(`
  mutation UpdateBookingMutation($bookingId: Int!, $startDateTime: DateTime!) {
    updateBooking(bookingId: $bookingId, startDateTime: $startDateTime) {
      id
    }
  }
`);

export const useUpdateBooking = () => {
  const [updateBookingMutation, { error: mutationError, loading: mutationLoading, data }] =
    useMutation<UpdateBookingMutationMutation, UpdateBookingMutationMutationVariables>(
      UPDATE_BOOKING,
      {
        awaitRefetchQueries: true,
        refetchQueries: [BOOKING_LIST_GET_BOOKINGS],
      },
    );

  const updateBooking = useCallback(
    (values: { bookingId: number; bookingStart: Dayjs }) => {
      return updateBookingMutation({
        variables: {
          bookingId: values.bookingId,
          startDateTime: values.bookingStart?.toISOString(),
        },
      });
    },
    [updateBookingMutation],
  );

  return {
    updateBooking,
    updateBookingLoading: mutationLoading,
    updateBookingError: mutationError,
    updateBookingData: data,
  };
};
